import React from 'react';

import { APP_CONFIG } from '../../../config';
import { useMembership } from '../../../customHooks/useMembership';
import { useProducts } from '../../../customHooks/useProducts';
import { default as Msg } from '@/i18n/components/FormattedMessage';

export const MembershipManagement = () => {
  const { contractSource } = useMembership();
  const { products } = useProducts();

  if (!contractSource && !products?.length) {
    return null;
  }

  const defaultSource = products?.length ? 'CHECKOUT' : 'MYSCOUT';
  const contractOverviewUrl =
    APP_CONFIG.contractOverviewUrl[contractSource ?? defaultSource] ?? APP_CONFIG.contractOverviewUrl[defaultSource];

  return (
    <div>
      <h2 className='font-heading-small-regular'>
        <Msg id='membershipManagement' defaultMessage='Manage membership' />
      </h2>
      <div className='with-icon'>
        <i className='is24-icon-chevron-right' />
        <a href={contractOverviewUrl}>
          <Msg id='membershipManagement' defaultMessage='Manage membership' />
        </a>
      </div>
    </div>
  );
};
